export default "__VITE_ASSET__2718fbe3__"